export default __webpack_public_path__ + "static/media/Ballroll_00033.798ffe3d.png";